import { useCallback, useEffect, useState } from "react";

// Single source of truth for branch locations. Replaces the duplicate
// getLocations() calls that each component used to fire independently.
export const useLocations = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`/api/fleet/forklift/getLocations`);
      if (!response.ok) {
        throw new Error(`Failed to load locations (${response.status})`);
      }
      const data = await response.json();
      setLocations(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e.message || "Failed to load locations");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { locations, loading, error, refetch };
};
